/*
Sohel 01/09/2023 2698951347 Implemented Copy Functionality
Sohel 01/10/2023 2698951347 changed url
kavyareddy 01/10/2023 2698951347 Integrated download print api
Sohel 01/12/2023 2699299906 Added download configuration
dilip 01/12/2023 2699299906 Added Map Exception Records values and reset.
dilip 01/12/2023 2699299906 Fixed message and status reset issue.
dilip 01/12/2023 2699299906 Fixed Mapped data reset issue.
Dilip 02/02/2023 3031450488 Integrated  download api for data manager Execution History
Dilip 02/02/2023 3031450488 Integrated  download api for data manager Execution
Ravi 02/23/2023 2780168262 implemented test functionality
Akhila 02/27/2023 2780168262 implemented preview file functionality
Akhila 03/17/2023 3075154998 download toast message and loader in preview file
Sohel 04/11/2023 3075154998 Fixed Error Toast Message Issue
Sohel 05/17/2023 3075154998 Add Import File Functionality
Akhila 05/18/2023 3075154998 loader added in run export
Sohel 05/25/2023 3075154998 Added Dialog message instead of Toast message
Ravi 05/23/2023 3075154998 Added Export Format file Field
Ravi 06/23/2023 3075154998 fixed submit issue
*/
import { createSlice } from '@reduxjs/toolkit';
import download from '../../../util/DownloadLink';
import { httpGet, httpPost } from '../../../util/Rest';
import { fetchDownloadSuccess } from '../PreviewFileData';
import { EXPORT_FORMAT_TYPE } from '../../../constants/Lookup';
import { submissionEnd } from '../CommonActions/commonActions';

const initialState = {
  isBasicInfoLoading: false,
  basicInfoErrorMsg: null,
  basicInfoSuccessMsg: null,
  addBasicInfoStatus: null,
  dmCode: '',
  dataManagerId: 0,
  isSelectFieldLoading: false,
  SelectFieldSuccessMsg: null,
  SelectFieldErrorMsg: null,
  SelectFieldStatus: null,
  basicInfoData: {},
  recordsData: [],
  recordsExceptionData: [],
  allDataManagerCode: [],
  selectedProcessorFields: {},
  isNotesLoading: false,
  notesSuccessMsg: null,
  addSystemNotesStatus: null,
  mappedRecordsStatus: null,
  mappedExcRecordsStatus: null,
  parentRecordException: null,
  viewFormFileUrl: null,
  downloadSuccessMsg: null,
  configurationUrl: '',
  dockey: '',
  defaultErrorFlag: '',
  exportFileSuccessMsg: null,
  isExportLoader: false,
  exportFormatTypeData: {},
  postCopyLoading: false,
};

const dataManager = createSlice({
  name: 'dataManagerGroup',
  initialState,
  reducers: {
    fetchBasicInfo: (state) => {
      state.isBasicInfoLoading = true;
      state.basicInfoErrorMsg = null;
    },
    fetchCopyStart: (state) => {
      state.postCopyLoading = true;
      state.basicInfoErrorMsg = null;
    },
    fetchExport: (state) => {
      state.isExportLoader = true;
      state.basicInfoErrorMsg = null;
    },
    fetchBasicInfoError: (state, action) => {
      state.basicInfoErrorMsg = action.payload;
      state.isBasicInfoLoading = false;
    },
    fetchTestError: (state, action) => {
      state.testError = action.payload;
      state.isBasicInfoLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    postBasicInfoData: (state, action) => {
      state.isBasicInfoLoading = false;
      state.addBasicInfoStatus = action.payload?.status;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = action.payload?.message;
      state.dmCode = action.payload?.response?.dmCode;
      state.dataManagerId = action.payload?.response?.dataManagerId;
    },
    exportFileData: (state, action) => {
      state.isExportLoader = false;
      state.basicInfoErrorMsg = null;
      state.exportFileSuccessMsg = action.payload?.message;
    },
    postCopyData: (state, action) => {
      state.postCopyLoading = false;
      state.addBasicInfoStatus = action.payload?.status;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = action.payload?.message;
      state.dmCode = action.payload?.response?.dmCode;
      state.dataManagerId = action.payload?.response?.dataManagerId;
    },
    postMapRecordData: (state, action) => {
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = action.payload?.message;
      state.mappedRecordsStatus = action.payload?.status;
    },
    postMapExcRecordData: (state, action) => {
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = action.payload?.message;
      state.mappedExcRecordsStatus = action.payload?.status;
    },
    getAllDataManagerCode: (state, action) => {
      state.allDataManagerCode = action.payload;
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
    },
    getBasicInfoData: (state, action) => {
      state.addBasicInfoStatus = null;
      state.isBasicInfoLoading = false;
      state.basicInfoSuccessMsg = null;
      state.basicInfoErrorMsg = null;
      state.basicInfoData = action.payload;
      state.dmCode = action.payload?.dmCode || '';
      state.dataManagerId = action.payload?.dataManagerId;
    },
    getPrintData: (state, action) => {
      state.addBasicInfoStatus = null;
      state.basicInfoSuccessMsg = action.payload.response;
      state.isBasicInfoLoading = false;
    },
    getMappedRecordsData: (state, action) => {
      state.addBasicInfoStatus = null;
      state.isBasicInfoLoading = false;
      state.basicInfoSuccessMsg = null;
      state.basicInfoErrorMsg = null;
      state.recordsData = action.payload;
    },
    getExceptionMappedRecordsData: (state, action) => {
      state.addBasicInfoStatus = null;
      state.isBasicInfoLoading = false;
      state.basicInfoSuccessMsg = null;
      state.basicInfoErrorMsg = null;
      state.recordsExceptionData = action.payload?.dmRecordResponseList || [];
      state.defaultErrorFlag = action.payload?.defaultErrorFlag;
    },
    resetBasicInfoData: (state, action) => {
      state.isBasicInfoLoading = false;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.addBasicInfoStatus = null;
      state.exportFileSuccessMsg = null;
      state.isExportLoader = false;
      state.postCopyLoading = false;
    },
    resetDataManagerData: (state) => {
      state.basicInfoData = {};
      state.dmCode = '';
      state.dataManagerId = 0;
    },
    resetRecordData: (state) => {
      state.recordsData = [];
      state.recordsExceptionData = [];
      state.selectedProcessorFields = [];
      state.mappedExcRecordsStatus = null;
      state.mappedRecordsStatus = null;
      state.SelectFieldErrorMsg = null;
      state.SelectFieldStatus = null;
      state.SelectFieldSuccessMsg = null;
      state.selectedProcessorFields = null;
      state.defaultErrorFlag = '';
    },
    fetchSelectField: (state, action) => {
      state.isSelectFieldLoading = true;
      state.SelectFieldErrorMsg = null;
    },
    fetchSelectFieldError: (state, action) => {
      state.SelectFieldErrorMsg = action.payload;
      state.isSelectFieldLoading = false;
    },
    postSelectFieldData: (state, action) => {
      state.isSelectFieldLoading = false;
      state.SelectFieldSuccessMsg = action.payload?.message;
      state.SelectFieldStatus = action.payload?.status;
      state.SelectFieldErrorMsg = null;
      state.dmCode = action.payload?.response[0]?.dataManagerCode;
      state.dataManagerId = action.payload?.response[0]?.dmId;
    },
    resetSelectFieldsData: (state) => {
      state.SelectFieldErrorMsg = null;
      state.SelectFieldSuccessMsg = null;
      state.SelectFieldErrorMsg = null;
      state.isSelectFieldLoading = false;
    },
    getSelectedFieldsData: (state, action) => {
      state.SelectFieldErrorMsg = null;
      state.SelectFieldStatus = null;
      state.SelectFieldSuccessMsg = null;
      state.selectedProcessorFields = action.payload;
      state.isSelectFieldLoading = false;
    },
    fetchNotesStart: (state) => {
      state.isNotesLoading = true;
      state.errorMsg = null;
    },
    postSystemNotesData: (state, action) => {
      state.addSystemNotesStatus = action.payload.status;
      state.isNotesLoading = false;
      state.errorMsg = null;
      state.notesSuccessMsg = action.payload.message;
    },
    resetSystemNotesData: (state) => {
      state.isNotesLoading = false;
      state.addSystemNotesStatus = null;
      state.notesSuccessMsg = null;
      state.errorMsg = null;
    },
    setParentRecordException: (state, action) => {
      state.parentRecordException = action.payload;
    },
    resetMsgAndStatus: (state, action) => {
      state.addBasicInfoStatus = null;
      state.basicInfoErrorMsg = null;
      state.basicInfoSuccessMsg = null;
      state.mappedRecordsStatus = null;
      state.mappedExcRecordsStatus = null;
      state.isSelectFieldLoading = false;
      state.SelectFieldSuccessMsg = null;
      state.SelectFieldStatus = null;
      state.SelectFieldErrorMsg = null;
    },
    fetchSuccessGenerateUrl: (state, action) => {
      state.viewFormFileUrl = action.payload.data;
      state.isBasicInfoLoading = false;
    },
    resetFileUrl: (state, action) => {
      state.viewFormFileUrl = null;
    },
    postDownloadData: (state, action) => {
      state.isBasicInfoLoading = false;
      state.downloadSuccessMsg = `${
        action.payload === 'Export' ? 'Export' : 'Import'
      } Execution History Downloaded Successfully`;
    },
    downloadResetMsg: (state, action) => {
      state.downloadSuccessMsg = null;
    },
    getTestData: (state, action) => {
      state.addBasicInfoStatus = null;
      state.basicInfoSuccessMsg = action.payload.message;
      state.isBasicInfoLoading = false;
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.isBasicInfoLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.isBasicInfoLoading = false;
      state.dockey = action.payload;
    },
    resetTestError: (state, action) => {
      state.testError = null;
      state.isBasicInfoLoading = false;
    },
    fetchExportFormatType: (state, action) => {
      state.exportFormatTypeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});

export const {
  fetchBasicInfo,
  fetchBasicInfoError,
  postBasicInfoData,
  resetBasicInfoData,
  getBasicInfoData,
  getPrintData,
  resetDataManagerData,
  getAllDataManagerCode,
  fetchSelectField,
  fetchSelectFieldError,
  postSelectFieldData,
  resetSelectFieldsData,
  getSelectedFieldsData,
  postMapRecordData,
  postMapExcRecordData,
  getMappedRecordsData,
  resetRecordData,
  postCopyData,
  fetchNotesStart,
  postSystemNotesData,
  resetSystemNotesData,
  fetchSuccess,
  getExceptionMappedRecordsData,
  setParentRecordException,
  resetMsgAndStatus,
  fetchSuccessGenerateUrl,
  resetFileUrl,
  postDownloadData,
  downloadResetMsg,
  getTestData,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
  exportFileData,
  fetchExport,
  fetchTestError,
  resetTestError,
  fetchExportFormatType,
  fetchCopyStart,
} = dataManager.actions;

export default dataManager.reducer;

export const postBasicInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(`dm/save/datamanager`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postBasicInfoData(data));
          // dispatch(exportFileData(data));
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};
export const exportFileExecute = (details) => {
  return (dispatch) => {
    dispatch(fetchExport());
    httpPost(`data-manager/execution/dmexport`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(exportFileData(data));
        } else if (data?.data?.status === 400) {
          fetchBasicInfoError(data?.data?.error);
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};

export const postCopy = (details) => {
  return (dispatch) => {
    dispatch(fetchCopyStart());
    httpPost(`dm/copy/datamanager`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postCopyData(data));
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};
export const postMapRecordInfo = (details, exception) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(`dm/save/recordMap`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          !exception ? dispatch(postMapRecordData(data)) : dispatch(postMapExcRecordData(data));
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};

export const fetchBasicInfoData = ({ dataManagerId, tabType }) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpGet(`dm/get/datamanager/${dataManagerId}`)
      .then((data) => {
        console.log(tabType);
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchBasicInfoError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getBasicInfoData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};

export const getRecordMapData = (dmCode) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpGet(`dm/get/recordMap/field/${dmCode}/all`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchBasicInfoError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getMappedRecordsData(data?.response?.dmRecordResponseList));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};

export const getExceptionRecordMapData = (dmCode) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpGet(`dm/get/recordMap/field/${dmCode}/Exception`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchBasicInfoError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getExceptionMappedRecordsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};

export const resetBasicInfo = () => {
  return (dispatch) => {
    dispatch(resetBasicInfoData());
  };
};

export const resetDataManager = () => {
  return (dispatch) => {
    dispatch(resetDataManagerData());
  };
};
export const resetSelectFields = () => {
  return (dispatch) => {
    dispatch(resetSelectFieldsData());
  };
};

export const fetchAllDataManagerCode = (type) => {
  return (dispatch) => {
    httpGet(`dm/find/all/datamanagercodeanddescription/${type}`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllDataManagerCode(data?.response));
        } else {
          dispatch(fetchBasicInfoError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error?.data?.error));
      });
  };
};

export const postSelectField = (details) => {
  return (dispatch) => {
    dispatch(fetchSelectField());
    httpPost(`dm/save/data-manager/field`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postSelectFieldData(data));
        } else {
          dispatch(fetchSelectFieldError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchSelectFieldError(error.message));
      });
  };
};

export const fetchSelectedFieldsData = (dmCode, type) => {
  return (dispatch) => {
    dispatch(fetchSelectField());
    httpGet(`dm/get/dataManager/field/${dmCode}/${type}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchSelectFieldError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(getSelectedFieldsData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchSelectFieldError(error.message));
      });
  };
};
export const postSystemNotes = (details, type) => {
  const url = type === 'Import' ? `dm/save/importusernotes` : `dm/save/exportnotes`;
  return (dispatch) => {
    dispatch(fetchNotesStart());
    httpPost(url, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchSelectFieldError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchSelectFieldError(error.message));
      });
  };
};

export const postExportSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNotesStart());
    httpPost(`dm/save/exportnotes`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchSelectFieldError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchSelectFieldError(error.message));
      });
  };
};

export const postPrintImportMaster = (data, type) => {
  const url = type === 'Export' ? 'dm/print/exportManager' : `dm/print/import`;
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(url, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printExportMaster({ dockey: data?.message }, data, type));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error.message));
      });
  };
};

export const printExportMaster = (payload, postData, type) => {
  const url = type === 'Export' ? 'dm/generateurlexportmanagerprint' : 'dm/generateimportprinturl';
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(url, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(getPrintData(postData));
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(fetchDownloadSuccess(postData));
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error?.message));
      });
  };
};

export const postGenerateUrl = (payload, type) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(`data-manager/execution/generateurl`, payload)
      .then((data) => {
        if (data && data?.status === 200) {
          dispatch(postDownloadData(type));
          download(data.data);
        } else if (data && data?.data?.status === 500) {
          dispatch(fetchBasicInfoError(data?.data?.error));
        } else {
          dispatch(fetchBasicInfoError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error?.message));
      });
  };
};
export const ImportpostGenerateUrl = (payload, type) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(`data-manager/execution/generateurldmerror/execution`, payload)
      .then((data) => {
        if (data && data?.status === 200) {
          dispatch(postDownloadData(type));
          download(data.data);
        } else if (data && data?.data?.status === 500) {
          dispatch(fetchBasicInfoError(data?.data?.error));
        } else {
          dispatch(fetchBasicInfoError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error?.message));
      });
  };
};

export const postExecutionGenerateUrl = (payload, type) => {
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(`data-manager/execution/generateurlprint/execution`, payload)
      .then((data) => {
        if (data && data?.status === 200) {
          // dispatch(postDownloadData(type))
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(setDockey(payload?.dockey));
        } else if (data && data?.data?.status === 500) {
          dispatch(fetchBasicInfoError(data?.data?.error));
        } else {
          dispatch(fetchBasicInfoError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error?.message));
      });
  };
};
export const postTestImportMaster = (data, importFile) => {
  const url = importFile
    ? `data-manager/execution/execute`
    : `data-manager/execution/test/${data.dmId}/${data.type}`;
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(url, data)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchTestError(data?.data?.message));
        } else if (data && data.status && data.status === 200 && importFile) {
          // dispatch(testExportMaster({ dockey: data?.response }, data));
          dispatch(getTestData(data));
        } else if (data && data.status && data.status === 200 && !importFile) {
          dispatch(testExportMaster({ dockey: data?.response }, data));
        } else {
          dispatch(fetchTestError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchTestError(error.message));
      });
  };
};

export const testExportMaster = (payload, postData) => {
  const url = 'data-manager/execution/generateurlprint/testdataupdate';
  return (dispatch) => {
    dispatch(fetchBasicInfo());
    httpPost(url, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getTestData(postData));
          download(data.data);
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchBasicInfoError(error?.message));
      });
  };
};

export const getExportFormatType = () => {
  return (dispatch) => {
    // dispatch(fetchBasicInfo());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [EXPORT_FORMAT_TYPE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchExportFormatType(lookUpApiData.data));
        } else {
          dispatch(fetchBasicInfoError(data?.data?.error));
        }
      })
      .catch((error) => {
        // dispatch(fetchError(error.message));
        dispatch(fetchBasicInfoError(error?.message));
      });
  };
};

export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};

export const ResetUrl = () => {
  return (dispatch) => {
    dispatch(resetFileUrl());
  };
};

export const resetTestErrorMessage = () => {
  return (dispatch) => {
    dispatch(resetTestError());
  };
};
export const ResetDownloadMsg = () => {
  return (dispatch) => {
    dispatch(downloadResetMsg());
  };
};
